import { useToast } from '@airship-platform/airship-patterns';
import { OrganizationSOW } from '@airship-platform/airship-proposal';
import { IconButtonProps } from '@mui/material/IconButton';
import { useMemo } from 'react';
import { useAppointmentProposalOptionSOWs } from '../../data-access/appointmentProposalOptionSows';
import { AppointmentProposalOption } from '../../data-access/appointmentProposalOptions';
import { QuickAddButton } from '../../patterns';

interface QuickAddSOWButtonProps extends IconButtonProps {
  sow: OrganizationSOW;
  option?: AppointmentProposalOption;
}

const QuickAddSOWButton: React.FC<QuickAddSOWButtonProps> = ({
  sow,
  option,
}) => {
  const {
    createAppointmentProposalOptionSOW,
    getNextSortOrder,
    isLoadingSOWIds,
    proposalSows,
  } = useAppointmentProposalOptionSOWs();
  const { showToast } = useToast();

  const isAlreadyAdded = useMemo(
    () =>
      option
        ? proposalSows.some(
            (ps) =>
              ps.appointmentProposalOptionId ===
                option.appointmentProposalOptionId && ps.sowId === sow.sowId
          )
        : false,
    [proposalSows, option, sow.sowId]
  );

  if (!option) {
    return null;
  }

  const onClick = () =>
    createAppointmentProposalOptionSOW(
      option.appointmentId,
      option.appointmentProposalId,
      option.appointmentProposalOptionId,
      {
        jobId: option.jobId,
        sowId: sow.sowId,
        title: sow.title,
        summary: sow.summary,
        shortDescription: sow.shortDescription,
        sortOrder: getNextSortOrder(),
      }
    ).then(() => showToast(`Added ${sow.title} to ${option.name}`, 'success'));

  return (
    <QuickAddButton
      isLoading={isLoadingSOWIds.includes(sow.sowId)}
      isAlreadyAdded={isAlreadyAdded}
      disabled={!option || isAlreadyAdded || option.isReadOnly}
      onClick={onClick}
    />
  );
};

export default QuickAddSOWButton;
